import React, {useState} from 'react';

export default function RoomTypeModal({ initial, onClose, onSave }) {
  const [form, setForm] = useState(() =>
    initial ? { ...initial } : {
      room_type: '', capacity: '', description: '', price: '',
      original_price: '', bed_info: '', room_size_sqm: '', room_type_detail: '',
      breakfast_included: false, free_cancellation: true, no_prepayment: true
    }
  );
  const [error, setError] = useState('');

  const numericFields = ['capacity', 'price', 'original_price', 'room_size_sqm'];

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: numericFields.includes(name) ? value.replace(/[^0-9.]/g, '') : value }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (!form.room_type || !form.capacity || !form.price) {
      setError('Room type, capacity, and price are required.');
      return;
    }
    if (Number(form.capacity) <= 0) {
      setError('Capacity must be a positive number.');
      return;
    }
    if (Number(form.price) < 0) {
      setError('Price cannot be negative.');
      return;
    }
    setError('');
    onSave({
      ...form,
      capacity: Number(form.capacity),
      price: Number(form.price),
      original_price: form.original_price !== '' ? Number(form.original_price) : null,
      room_size_sqm: form.room_size_sqm !== '' ? Number(form.room_size_sqm) : null,
    });
    onClose();
  };

  return (
    <div className="facility-modal-overlay">
      <div className="facility-modal">
        <h3>{initial ? 'Edit Room Type' : 'Add Room Type'}</h3>
        <form onSubmit={handleSubmit}>
          <div className="modal-row">
            <label>Room Type</label>
            <input name="room_type" value={form.room_type} onChange={handleChange} required />
          </div>
          <div className="modal-row">
            <label>Capacity</label>
            <input name="capacity" value={form.capacity} onChange={handleChange} required />
          </div>
          <div className="modal-row">
            <label>Description</label>
            <textarea name="description" value={form.description} onChange={handleChange} />
          </div>
          <div className="modal-row">
            <label>Price</label>
            <input name="price" value={form.price} onChange={handleChange} required />
          </div>
          <div className="modal-row">
            <label>Original Price (before discount, optional)</label>
            <input name="original_price" type="text" value={form.original_price || ''} onChange={handleChange} placeholder="Leave blank if no discount" />
          </div>
          <div className="modal-row">
            <label>Bed Info</label>
            <input name="bed_info" value={form.bed_info || ''} onChange={handleChange} placeholder="e.g. 1 queen bed" />
          </div>
          <div className="modal-row">
            <label>Room Size (m2)</label>
            <input name="room_size_sqm" type="text" value={form.room_size_sqm || ''} onChange={handleChange} placeholder="e.g. 35" />
          </div>
          <div className="modal-row">
            <label>Room Detail</label>
            <input name="room_type_detail" value={form.room_type_detail || ''} onChange={handleChange} placeholder="e.g. Private room . En-suite bathroom" />
          </div>
          <div className="modal-row" style={{flexDirection:'row', gap:16, alignItems:'center'}}>
            <label style={{display:'flex',alignItems:'center',gap:6,fontWeight:'normal'}}>
              <input type="checkbox" name="breakfast_included" checked={!!form.breakfast_included} onChange={e => setForm(f => ({...f, breakfast_included: e.target.checked}))} />
              Breakfast Included
            </label>
            <label style={{display:'flex',alignItems:'center',gap:6,fontWeight:'normal'}}>
              <input type="checkbox" name="free_cancellation" checked={form.free_cancellation !== false} onChange={e => setForm(f => ({...f, free_cancellation: e.target.checked}))} />
              Free Cancellation
            </label>
            <label style={{display:'flex',alignItems:'center',gap:6,fontWeight:'normal'}}>
              <input type="checkbox" name="no_prepayment" checked={form.no_prepayment !== false} onChange={e => setForm(f => ({...f, no_prepayment: e.target.checked}))} />
              No Prepayment
            </label>
          </div>
          {error && <div className="modal-error">{error}</div>}
          <div className="modal-actions">
            <button type="button" onClick={onClose}>Cancel</button>
            <button type="submit">Save</button>
          </div>
        </form>
      </div>
    </div>
  );
}
